import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable consistent-return */
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import toastService from "Root/profile/toastService";
import { apiUpdateCommunicationPrefs } from "Root/api/apiProfile";
import FormCheckbox from "../../common/FormCheckbox";
import ProfileDataCardTitle from "../../common/ProfileDataCardTitle/ProfileDataCardTitle";
import AccountContext from "../context";
import styles from "./styles.module.css";
const CommunicationPreferences = () => {
    const { editMode, communicationPrefs, onChangeCommunicationData, userAccount } = useContext(AccountContext);
    // const { setGlobalLoading } = useContext(GeneralContext);
    const dispatch = useDispatch();
    const onChange = async (value, name) => {
        if (!userAccount.phone && name === "sms_opt_in") {
            return toastService.errorMessage("Please add your mobile to opt into SMS");
        }
        try {
            dispatch(setGlobalLoading(true));
            onChangeCommunicationData(value, name);
            await apiUpdateCommunicationPrefs(userAccount, name, value);
            toastService.successMessage("Communication preferences updated successfully ");
        }
        catch (e) {
            onChangeCommunicationData(!value, name);
            toastService.errorMessage(e);
        }
        finally {
            dispatch(setGlobalLoading(false));
        }
    };
    return (_jsxs("div", { className: "my-profile__basics-container my-profile__basics", children: [_jsx(ProfileDataCardTitle, { title: "Communication Preferences", editMode: editMode.communication, name: "communication" }), _jsxs("div", { className: `${styles.pref_wrapper} my-profile__items-wrapper`, children: [_jsx(FormCheckbox, { checked: communicationPrefs.sms_opt_in, id: "sms", name: "sms_opt_in", onChange: onChange, value: "sms", label: "Receive SMS messages with order, shipping and delivery notifications. You can unsubscribe at any time. Normal SMS rates apply. Terms" }), _jsx(FormCheckbox, { checked: communicationPrefs.email_opt_in, id: "email", name: "email_opt_in", onChange: onChange, value: "email", label: "Receive personalized content, workouts, and exclusive offers by email. Your data is safe with us, and you can unsubscribe at any time. You will still receive order, shipping and delivery emails." })] }), _jsx("a", { className: "truevault-polaris-privacy-notice", href: "https://privacy.gainful.com/privacy-policy#financial-incentive", hidden: true, target: "_blank", rel: "noreferrer", children: "Notice of Financial Incentive" })] }));
};
export default CommunicationPreferences;
